export default __webpack_public_path__ + "static/media/akar-icons_twitter-fill.d2f3ebbf.svg";